import { render, staticRenderFns } from "./PaidWallet.vue?vue&type=template&id=adc29988"
import script from "./PaidWallet.vue?vue&type=script&lang=js"
export * from "./PaidWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports